export const LegalDocument = {
  AutomaticSummary: "forms/gdpr/2024-march-summaries",
};
